import * as React from "react";
function SvgMicOff(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 6.586L4.707 3.293 3.293 4.707 8 9.414V12a4 4 0 006.032 3.446l.803.803c-.657.446-1.561.751-2.835.751-1.505 0-2.494-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2v-.002V9l-.002.035-.006.114v.014a17.932 17.932 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.049 1.35 3.512 1.52V22h2v-3.054c1.33-.149 2.409-.597 3.266-1.266l3.027 3.027 1.414-1.414-3.096-3.096c.42-.65.712-1.352.914-2.04.59-2.001.481-4.138.442-4.906a6.362 6.362 0 01-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.12.404-.27.79-.456 1.144l-.705-.704c.352-.596.554-1.29.554-2.032V6a4 4 0 10-8 0v.586zm2 4.828V12a2 2 0 002.518 1.932L10 11.414zm3.932 1.104L10 8.586V6a2 2 0 014 0v6a2 2 0 01-.068.518z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgMicOff);
export default ForwardRef;
